import { API } from '@Providers';

interface Payload {
  entity: string;
  exclude_id?: string;
  field?: string;
  fields?: { name: string; value: string }[];
  value?: any;
}

export default async function (payload: Payload) {
  const endpoint = '/api/shelter/forms/checkDuplicate';

  return API({ endpoint, forwardError: true, method: 'post', payload }).then((result: any) => result);
}
